import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { initialize } from './actions';
const actionHandler = handleActions({
    [initialize.toString()]: (state, { payload: { config } })=>_object_spread({}, state, config)
}, {
    csrfToken: '',
    sharedApiBasePath: ''
});
export default {
    [reduxKey]: actionHandler
};

//# sourceMappingURL=reducers.js.map